export enum RichTextNodeKind {
  Text = 'text',
  Break = 'break',
  Paragraph = 'paragraph',
  // a <div>/heading: its own line, but without the blank line a paragraph gets. Outlook
  // emits one per line, so treating it as a paragraph would double-space every description.
  Block = 'block',
  List = 'list',
  ListItem = 'list-item',
  Link = 'link',
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
}

// The parsed shape of a provider description. One tree feeds both the rendered read view
// and the plain text the editor works on, so what is shown and what is edited cannot drift.
export type RichTextNode =
  | { kind: RichTextNodeKind.Text; value: string }
  | { kind: RichTextNodeKind.Break }
  | { kind: RichTextNodeKind.Paragraph; children: RichTextNode[] }
  | { kind: RichTextNodeKind.Block; children: RichTextNode[] }
  | { kind: RichTextNodeKind.List; ordered: boolean; children: RichTextNode[] }
  | { kind: RichTextNodeKind.ListItem; children: RichTextNode[] }
  | { kind: RichTextNodeKind.Link; href: string; children: RichTextNode[] }
  | { kind: RichTextNodeKind.Bold; children: RichTextNode[] }
  | { kind: RichTextNodeKind.Italic; children: RichTextNode[] }
  | { kind: RichTextNodeKind.Underline; children: RichTextNode[] };
